import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Paper,
} from "@mui/material";

export default function ComplaintsTable({
  title,
  errors,
  yearType,
  complaintsFiled,
  onInputChange,
  disabled,
}) {
  const predefinedValues = [
    "Sexual Harassment",
    "Discrimination at workplace",
    "Child Labor",
    "Forced Labor / Involuntary Labor",
    "Wages",
    "Other human rights related issues",
  ];

  const renderTableRows = () => {
    return predefinedValues.map((value, index) => {
      const complaintKey = Object.keys(complaintsFiled[yearType])[index];
      const data = complaintsFiled[yearType][complaintKey] || {};

      return (
        <TableRow key={index}>
          <TableCell sx={{ borderRight: "1px solid #ddd" }}>{value}</TableCell>

          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
            <TextField
              disabled={disabled}
              value={data.fliedYear !== undefined ? data.fliedYear : ""}
              onChange={(e) =>
                onInputChange(e, yearType, complaintKey, "fliedYear")
              }
              placeholder="No. of Complaints"
              size="small"
              variant="outlined"
              error={Boolean(errors[`${yearType}.${complaintKey}.fliedYear`])}
              InputProps={{ disableUnderline: true }}
              sx={{
                "& .MuiOutlinedInput-root": { height: "1rem" },
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              }}
            />
          </TableCell>
          <TableCell sx={{ borderRight: "1px solid #ddd" }}>
            <TextField
              disabled={disabled}
              value={data.pending !== undefined ? data.pending : ""}
              onChange={(e) =>
                onInputChange(e, yearType, complaintKey, "pending")
              }
              placeholder="No. of Pending Resolution"
              size="small"
              variant="outlined"
              error={Boolean(errors[`${yearType}.${complaintKey}.pending`])}
              InputProps={{ disableUnderline: true }}
              sx={{
                "& .MuiOutlinedInput-root": { height: "1rem" },
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              }}
            />
          </TableCell>
          <TableCell>
            <TextField
              disabled={disabled}
              value={data.remark || ""}
              onChange={(e) =>
                onInputChange(e, yearType, complaintKey, "remark")
              }
              placeholder="Type Here"
              size="small"
              variant="outlined"
              error={Boolean(errors[`${yearType}.${complaintKey}.remark`])}
              InputProps={{ disableUnderline: true }}
              sx={{
                "& .MuiOutlinedInput-root": { height: "auto" },
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              }}
              multiline
              minRows={1}
            />
          </TableCell>
        </TableRow>
      );
    });
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ borderRadius: "10px", width: "99%", marginLeft: "0.9rem" }}
    >
      <Table>
        <TableHead
          sx={{ backgroundColor: "#1C486B", borderBottom: "1px solid #D32F2F" }}
        >
          <TableRow>
            <TableCell
              sx={{ color: "white", borderRight: "1px solid white" }}
            ></TableCell>
            <TableCell sx={{ color: "white", borderRight: "1px solid white" }}>
              Filed during the year
            </TableCell>
            <TableCell sx={{ color: "white", borderRight: "1px solid white" }}>
              Pending resolution at the end of year
            </TableCell>
            <TableCell sx={{ color: "white" }}>Remarks</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ borderBottom: "1px solid " }}>
          {renderTableRows()}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
